import * as React from 'react';
import { Attachment } from '../../../typedefs/store';
import VehicleAttachment from './VehicleAttachment';
import CalculatorAttachment from './CalculatorAttachment';
import BrochureAttachment from './BrochureAttachment';
import AccoladeAttachment from './AccoladeAttachment';
import IncentiveAttachment from './IncentiveAttachment';
import VideoAttachment from './VideoAttachment';
import UploadedVideoAttachment from './UploadedVideoAttachment';
import ImageAttachment from './ImageAttachment';
import LinkAttachment from './LinkAttachment';

interface Props {
    attachment: Attachment;
    openLinksExternally: boolean;
}

const Attachment: React.SFC<Props> = ({ attachment, openLinksExternally }) => {
    switch (attachment.doctype) {
        case 'vehicle':
            return (
                <VehicleAttachment
                    attachment={attachment}
                    openLinksExternally={openLinksExternally}
                />
            );
        case 'calculator':
            return <CalculatorAttachment attachment={attachment} />;
        case 'brochure':
            return <BrochureAttachment attachment={attachment} />;
        case 'accolade':
            return <AccoladeAttachment attachment={attachment} />;
        case 'incentive':
            return <IncentiveAttachment attachment={attachment} />;
        case 'video':
            return <VideoAttachment attachment={attachment} />;
        case 'uploadedvideo':
            return <UploadedVideoAttachment attachment={attachment} />;
        case 'image':
            return <ImageAttachment attachment={attachment} />;
        case 'link':
            return (
                <LinkAttachment attachment={attachment} openLinksExternally={openLinksExternally} />
            );
        default:
            return <div>unknown attachment</div>;
    }
};

export default Attachment;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/Attachment.tsx